import { ActionType, PayloadErrorType } from '../../types/reduxTypes';
import { CLEAR_SIGNUP_DATA, REQUEST_SIGNUP, REQUEST_SIGNUP_FAILED, REQUEST_SIGNUP_SUCCESS } from '../constants';
import { SignUpPayloadType } from '../actions/signUpActions';
import { signUpType } from '../../types/stateTypes';

const initialState: signUpType = {
  email: '',
  errorText: '',
  loading: false,
  password: '',
  success: false,
};

export default (state = initialState, action: ActionType<SignUpPayloadType | PayloadErrorType>): signUpType => {
  switch (action.type) {
    case CLEAR_SIGNUP_DATA: {
      return { ...initialState };
    }
    case REQUEST_SIGNUP: {
      const { email, password } = action.payload as SignUpPayloadType;
      return { ...state, email, loading: true, password };
    }
    case REQUEST_SIGNUP_FAILED: {
      const { message } = action.payload as PayloadErrorType;
      return { ...state, errorText: message, loading: false };
    }
    case REQUEST_SIGNUP_SUCCESS: {
      return { ...state, loading: false, success: true };
    }

    default: {
      return state;
    }
  }
};
